<template>
    <div class="oncallsuperbtn-frame">
        <div class="oncallsuperbtn-wrap" :class="{ 'helper-widget_visible': scrolled }">
            <div v-if="opened" style=" position: absolute;
          bottom: 100%;
          right: 0;
          z-index: 10;
          justify-content: flex-end;
          flex-direction: column;
          align-items: flex-end;
        " class="helper-list" :class="{ 'list-active': opened }">
                <div v-for="(item, idx) in listItems" :key="idx" @click="clickItem(idx)" v-show="item.display"
                    class="oncallsuperbtn-item">
                    <span>{{ item.title }}</span>
                    <div v-html="item.iconMini"></div>
                </div>
            </div>
            <div class="oncallsuperbtn" :class="{ 'btn-active': opened }"
                :style="!opened ? `background: linear-gradient(90deg, #03ECC9 0%, #2E80EA 100%);` : ``">

                <transition name="fade" mode="out-in">
                    <div class="btn-trigger absolute z-10" @click="openList" v-html="currIcon" :style="{
                        opacity: changeIcon ? 0 : 1,
                        width: changeIcon ? '0px' : '120px',
                        height: changeIcon ? '0px' : '120px',
                        transition: 'opacity .5s ease-in-out, width .5s ease-in-out, height 1s ease-in-out',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }"></div>
                </transition>
                <div class="cross-icon absolute" @click="closeList">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OnCallSuperBtn",
    setup() {
        return {};
    },
    data() {
        return {
            opened: false,
            currScroll: 0,
            hideLimit: 300,
            changeIcon: false,
            currIndex: 0,
            currIcon: "",
            chatVisible: false,
            jivo_api: null,
            callmeOpened: false,
            callmeFlag: {
                fromAppointButton: false,
            },
            listItems: [
                {
                    title: "Написать в онлайн-чат",
                    display: false,
                    iconBig:
                        `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_47_27)">
          <path d="M29 22H27V24H23V41H32V39H25V30H39V31H41V24H37V22H35V24H29V22Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M40 32.5858L34 38.5858V42H37.4142L43.4142 36L40 32.5858Z" fill="white"/>
          </g>
          <defs>
          <filter id="filter0_d_47_27" x="-16" y="-12" width="96" height="96" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="8"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.334862 0 0 0 0 0.377887 0 0 0 0 0.500814 0 0 0 0.2 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_47_27"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_47_27" result="shape"/>
          </filter>
          </defs>
          </svg>`,
                    iconMini:
                        `<svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19.567 2.35691C17.6894 0.79161 15.0643 0 11.9996 0C8.93487 0 6.30971 0.79161 4.43213 2.35691C2.53272 3.94042 1.49956 6.23347 1.49956 9C1.49956 9.8165 1.76889 10.8187 2.01215 11.578C2.26563 12.3691 2.53661 13.0322 2.61319 13.2158L2.62597 13.2461L2.63365 13.2641L2.6356 13.2688C2.64498 13.2957 2.72593 13.544 2.66811 13.9774C2.60803 14.4277 2.39109 15.1318 1.7027 16.0398L0.958984 17.0207L2.07147 17.5477C3.45858 18.2047 4.8443 17.9717 5.79552 17.6417C6.25189 17.4834 6.6362 17.2938 6.91531 17.1378C8.55699 17.8505 10.3803 18 11.9996 18C15.0643 18 17.6894 17.2084 19.567 15.6431C21.4664 14.0596 22.4996 11.7665 22.4996 9C22.4996 6.23347 21.4664 3.94042 19.567 2.35691ZM2.6356 13.2688L2.63478 13.2665L2.63625 13.2704L2.6356 13.2688ZM6.24951 9C6.24951 9.6904 6.80916 10.25 7.49951 10.25C8.18987 10.25 8.74951 9.6904 8.74951 9C8.74951 8.3096 8.18987 7.75 7.49951 7.75C6.80916 7.75 6.24951 8.3096 6.24951 9ZM10.7495 9C10.7495 9.6904 11.3092 10.25 11.9995 10.25C12.6899 10.25 13.2495 9.6904 13.2495 9C13.2495 8.3096 12.6899 7.75 11.9995 7.75C11.3092 7.75 10.7495 8.3096 10.7495 9ZM16.4995 10.25C15.8092 10.25 15.2495 9.6904 15.2495 9C15.2495 8.3096 15.8092 7.75 16.4995 7.75C17.1899 7.75 17.7495 8.3096 17.7495 9C17.7495 9.6904 17.1899 10.25 16.4995 10.25Z"
                  fill="url(#paint0_linear_10_55)"/>
            <defs>
              <linearGradient id="paint0_linear_10_55" x1="20.8348" y1="16.6086" x2="5.85928" y2="-1.31262"
                              gradientUnits="userSpaceOnUse">
                <stop stop-color="#03ECC9"/>
                <stop offset="1" stop-color="#2E80EA"/>
              </linearGradient>
            </defs>
          </svg>`,
                    goal: "oncallSuperBtnChat",
                },
                {
                    title: "Написать в WhatsApp",
                    display: true,
                    iconBig: `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.70731 16.743L2.33594 21.75L7.45988 20.4063C8.87171 21.1762 10.4612 21.582 12.0787 21.5826H12.0829C17.4101 21.5826 21.7465 17.2474 21.7488 11.92C21.7498 9.33805 20.7456 6.91034 18.9204 5.08391C17.0953 3.25747 14.6685 2.25131 12.083 2.25C6.75508 2.25 2.41936 6.58441 2.41712 11.9122C2.41508 13.6079 2.86009 15.2741 3.70731 16.743ZM9.66716 7.87275C9.48613 7.47063 9.29564 7.46248 9.12368 7.45552L8.66073 7.44987C8.49967 7.44987 8.23798 7.5103 8.01676 7.75202C8.0025 7.7676 7.98657 7.78461 7.96924 7.80309L7.96922 7.80311C7.71766 8.07157 7.17139 8.65454 7.17139 9.76618C7.17139 10.9452 8.02353 12.0848 8.15452 12.26L8.15459 12.2601L8.15745 12.2639C8.16601 12.2753 8.18178 12.2987 8.20456 12.3325L8.20847 12.3383C8.5156 12.7939 10.0123 15.014 12.2831 15.9094C14.1268 16.6365 14.6433 16.5758 15.0526 16.5277L15.057 16.5272C15.0991 16.5223 15.1401 16.5175 15.1813 16.5137C15.6242 16.4735 16.6102 15.9295 16.8113 15.3656C17.0124 14.8016 17.0126 14.3184 16.9523 14.2174C16.9038 14.1362 16.7904 14.0815 16.6223 14.0005C16.5812 13.9807 16.5367 13.9592 16.4892 13.9355C16.2475 13.8146 15.0603 13.2304 14.8389 13.1498C14.6176 13.0691 14.4566 13.029 14.2954 13.2707C14.1343 13.5125 13.672 14.0562 13.531 14.2174C13.39 14.3786 13.2493 14.3988 13.0076 14.2781C12.9683 14.2585 12.9149 14.2353 12.8489 14.2067L12.8487 14.2066C12.509 14.0593 11.8381 13.7684 11.0655 13.0795C10.3475 12.4393 9.8629 11.6487 9.72181 11.4071C9.58071 11.1655 9.70683 11.0347 9.82795 10.9144C9.89969 10.8427 9.98224 10.7424 10.0649 10.6418L10.065 10.6416C10.1073 10.5903 10.1495 10.5389 10.1904 10.4914C10.2926 10.3723 10.3368 10.282 10.3966 10.1597L10.397 10.159C10.4078 10.1368 10.4192 10.1134 10.4316 10.0887C10.512 9.92777 10.4719 9.78641 10.4115 9.66569C10.3858 9.6143 10.286 9.36842 10.1633 9.06608C9.99776 8.65802 9.79046 8.14712 9.66716 7.87275Z" fill="white"/>
            </svg>
            `,
                    iconMini:
                        `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.70731 16.743L2.33594 21.75L7.45988 20.4063C8.87171 21.1762 10.4612 21.582 12.0787 21.5826H12.0829C17.4101 21.5826 21.7465 17.2474 21.7488 11.92C21.7498 9.33805 20.7456 6.91034 18.9204 5.08391C17.0953 3.25747 14.6685 2.25131 12.083 2.25C6.75508 2.25 2.41936 6.58441 2.41712 11.9122C2.41508 13.6079 2.86009 15.2741 3.70731 16.743ZM9.66716 7.87275C9.48613 7.47063 9.29564 7.46248 9.12368 7.45552L8.66073 7.44987C8.49967 7.44987 8.23798 7.5103 8.01676 7.75202C8.0025 7.7676 7.98657 7.78461 7.96924 7.80309C7.71767 8.07156 7.17139 8.65454 7.17139 9.76618C7.17139 10.9452 8.02353 12.0848 8.15452 12.26L8.15745 12.2639C8.16601 12.2753 8.18178 12.2987 8.20456 12.3325L8.20847 12.3383C8.5156 12.7939 10.0123 15.014 12.2831 15.9094C14.1268 16.6365 14.6433 16.5758 15.0526 16.5277L15.057 16.5272C15.0991 16.5223 15.1401 16.5175 15.1813 16.5137C15.6242 16.4735 16.6102 15.9295 16.8113 15.3656C17.0124 14.8016 17.0126 14.3184 16.9523 14.2174C16.9038 14.1362 16.7904 14.0815 16.6223 14.0005C16.5812 13.9807 16.5367 13.9592 16.4892 13.9355C16.2475 13.8146 15.0603 13.2304 14.8389 13.1498C14.6176 13.0691 14.4566 13.029 14.2954 13.2707C14.1343 13.5125 13.672 14.0562 13.531 14.2174C13.39 14.3786 13.2493 14.3988 13.0076 14.2781C12.9683 14.2585 12.9149 14.2353 12.8489 14.2067C12.5091 14.0594 11.8381 13.7684 11.0655 13.0795C10.3475 12.4393 9.8629 11.6487 9.72181 11.4071C9.58071 11.1655 9.70683 11.0347 9.82795 10.9144C9.89969 10.8427 9.98224 10.7424 10.0649 10.6418C10.1072 10.5904 10.1495 10.5389 10.1904 10.4914C10.2926 10.3723 10.3368 10.282 10.3966 10.1597C10.4074 10.1375 10.4192 10.1134 10.4316 10.0887C10.512 9.92777 10.4719 9.78641 10.4115 9.66569C10.3858 9.6143 10.286 9.36842 10.1633 9.06608C9.99776 8.65802 9.79046 8.14712 9.66716 7.87275Z" fill="url(#paint0_linear_53_363)"/>
            <defs>
            <linearGradient id="paint0_linear_53_363" x1="17.5022" y1="19.9219" x2="5.30501" y2="5.35061" gradientUnits="userSpaceOnUse">
            <stop stop-color="#03ECC9"/>
            <stop offset="1" stop-color="#2E80EA"/>
            </linearGradient>
            </defs>
            </svg>
            `
                    ,
                    goal: "oncallSuperBtnWhatsApp",
                },
                {
                    title: "Перезвоните мне",
                    display: true,
                    iconBig:
                        `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_47_28)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M39.567 25.3569C37.6894 23.7916 35.0643 23 31.9996 23C28.9349 23 26.3097 23.7916 24.4321 25.3569C22.5327 26.9404 21.4996 29.2335 21.4996 32C21.4996 32.8165 21.7689 33.8187 22.0122 34.578C22.2656 35.3691 22.5366 36.0322 22.6132 36.2158L22.626 36.2461L22.6337 36.2641L22.6356 36.2688C22.645 36.2957 22.7259 36.544 22.6681 36.9774C22.608 37.4277 22.3911 38.1318 21.7027 39.0398L20.959 40.0207L22.0715 40.5477C23.4586 41.2047 24.8443 40.9717 25.7955 40.6417C26.2519 40.4834 26.6362 40.2938 26.9153 40.1378C28.557 40.8505 30.3803 41 31.9996 41C35.0643 41 37.6894 40.2084 39.567 38.6431C41.4664 37.0596 42.4996 34.7665 42.4996 32C42.4996 29.2335 41.4664 26.9404 39.567 25.3569ZM22.6356 36.2688L22.6348 36.2665L22.6363 36.2704L22.6356 36.2688ZM26.2495 32C26.2495 32.6904 26.8092 33.25 27.4995 33.25C28.1899 33.25 28.7495 32.6904 28.7495 32C28.7495 31.3096 28.1899 30.75 27.4995 30.75C26.8092 30.75 26.2495 31.3096 26.2495 32ZM30.7495 32C30.7495 32.6904 31.3092 33.25 31.9995 33.25C32.6899 33.25 33.2495 32.6904 33.2495 32C33.2495 31.3096 32.6899 30.75 31.9995 30.75C31.3092 30.75 30.7495 31.3096 30.7495 32ZM36.4995 33.25C35.8092 33.25 35.2495 32.6904 35.2495 32C35.2495 31.3096 35.8092 30.75 36.4995 30.75C37.1899 30.75 37.7495 31.3096 37.7495 32C37.7495 32.6904 37.1899 33.25 36.4995 33.25Z" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_d_47_28" x="-16" y="-12" width="96" height="96" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="8"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.334862 0 0 0 0 0.377887 0 0 0 0 0.500814 0 0 0 0.2 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_47_28"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_47_28" result="shape"/>
            </filter>
            </defs>
            </svg>`,
                    iconMini:
                        `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 3.00012V4.00012C3 13.389 10.6112 21.0002 20 21.0002H21V14.4561L15.7152 12.8707L14.1216 14.4644C12.2053 13.3854 10.6148 11.7948 9.5358 9.87854L11.1295 8.28488L9.54403 3.00012H3Z"
              fill="white"/>
            <path
              d="M3 3.00012V4.00012C3 13.389 10.6112 21.0002 20 21.0002H21V14.4561L15.7152 12.8707L14.1216 14.4644C12.2053 13.3854 10.6148 11.7948 9.5358 9.87854L11.1295 8.28488L9.54403 3.00012H3Z"
              fill="url(#paint0_linear_10_67)"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19.9998 10.0002H13.9998V4.00015H15.9998V6.58594L19.9998 2.58594L21.4141 4.00015L17.4141 8.00015H19.9998V10.0002Z"
                  fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M19.9998 10.0002H13.9998V4.00015H15.9998V6.58594L19.9998 2.58594L21.4141 4.00015L17.4141 8.00015H19.9998V10.0002Z"
                  fill="url(#paint1_linear_10_67)"/>
            <defs>
              <linearGradient id="paint0_linear_10_67" x1="19.6088" y1="19.6088" x2="4.39119" y2="4.39115"
                              gradientUnits="userSpaceOnUse">
                <stop stop-color="#03ECC9"/>
                <stop offset="1" stop-color="#2E80EA"/>
              </linearGradient>
              <linearGradient id="paint1_linear_10_67" x1="20.841" y1="9.42708" x2="14.5728" y2="3.15885"
                              gradientUnits="userSpaceOnUse">
                <stop stop-color="#03ECC9"/>
                <stop offset="1" stop-color="#2E80EA"/>
              </linearGradient>
            </defs>
          </svg>`,
                    goal: "oncallSuperBtnCallMe",
                },
                {
                    title: "Позвонить",
                    display: true,
                    iconBig: `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3V4C3 13.3888 10.6112 21 20 21H21V14.456L15.7152 12.8705L14.1216 14.4642C12.2053 13.3852 10.6148 11.7947 9.5358 9.87842L11.1295 8.28476L9.54403 3H3Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9999 3H20.9999V9H18.9999V6.41421L14.9999 10.4142L13.5857 9L17.5857 5H14.9999V3Z" fill="white"/>
          </svg>`,
                    iconMini: `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 3V4C3 13.3888 10.6112 21 20 21H21V14.456L15.7152 12.8705L14.1216 14.4642C12.2053 13.3852 10.6148 11.7947 9.5358 9.87842L11.1295 8.28476L9.54403 3H3Z" fill="url(#paint0_linear_53_301)"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9999 3H20.9999V9H18.9999V6.41421L14.9999 10.4142L13.5857 9L17.5857 5H14.9999V3Z" fill="url(#paint1_linear_53_301)"/>
          <defs>
          <linearGradient id="paint0_linear_53_301" x1="17.0625" y1="19.3125" x2="5.8125" y2="5.8125" gradientUnits="userSpaceOnUse">
          <stop stop-color="#03ECC9"/>
          <stop offset="1" stop-color="#2E80EA"/>
          </linearGradient>
          <linearGradient id="paint1_linear_53_301" x1="19.378" y1="9.71912" x2="14.7442" y2="4.15847" gradientUnits="userSpaceOnUse">
          <stop stop-color="#03ECC9"/>
          <stop offset="1" stop-color="#2E80EA"/>
          </linearGradient>
          </defs>
          </svg>
          `,
                    goal: "oncallSuperBtnCall",
                },
                {
                    title: "Вызвать врача",
                    display: true,
                    iconBig:
                        `<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_47_29)">
            <path d="M23 23.0002V24.0002C23 33.389 30.6112 41.0002 40 41.0002H41V34.4561L35.7152 32.8707L34.1216 34.4644C32.2053 33.3854 30.6148 31.7948 29.5358 29.8786L31.1295 28.2849L29.544 23.0002H23Z" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M39.9998 30.0002H33.9998V24.0001H35.9998V26.5859L39.9998 22.5859L41.4141 24.0001L37.4141 28.0001H39.9998V30.0002Z" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_d_47_29" x="-16" y="-12" width="96" height="96" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dy="4"/>
            <feGaussianBlur stdDeviation="8"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.334862 0 0 0 0 0.377887 0 0 0 0 0.500814 0 0 0 0.2 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_47_29"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_47_29" result="shape"/>
            </filter>
            </defs>
            </svg>`,
                    iconMini:
                        `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 2H7V4H3V21H12V19H5V10H19V11H21V4H17V2H15V4H9V2Z" fill="white"/>
            <path d="M9 2H7V4H3V21H12V19H5V10H19V11H21V4H17V2H15V4H9V2Z" fill="url(#paint0_linear_10_70)"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 12.5858L14 18.5858V22H17.4142L23.4142 16L20 12.5858Z"
                  fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20 12.5858L14 18.5858V22H17.4142L23.4142 16L20 12.5858Z"
                  fill="url(#paint1_linear_10_70)"/>
            <defs>
              <linearGradient id="paint0_linear_10_70" x1="19.6088" y1="19.5313" x2="3.56926" y2="4.3359"
                              gradientUnits="userSpaceOnUse">
                <stop stop-color="#03ECC9"/>
                <stop offset="1" stop-color="#2E80EA"/>
              </linearGradient>
              <linearGradient id="paint1_linear_10_70" x1="22.6866" y1="21.2723" x2="14.7276" y2="13.3133"
                              gradientUnits="userSpaceOnUse">
                <stop stop-color="#03ECC9"/>
                <stop offset="1" stop-color="#2E80EA"/>
              </linearGradient>
            </defs>
          </svg>
            `,
                    goal: "oncallSuperBtnCallDoctor",
                },
            ],
            formContent: {
                formTitle: "Заявка",
                formText: "Оставьте заявку и наш менеджер свяжется с вами в ближайшее время",
                successTitle: "Готово!",
                successText: "Скоро вам перезвонят.",
                sms: false
            }
        }
    },
    methods: {
        clickItem(idx) {
            console.log('clickItem', idx);
            const goalMap = {
                0: 'superbtn-chat', // чат
                1: 'superbtn-wa', // WhatsApp
                2: 'superbtn-callme', // Перезвоните мне
                3: 'superbtn-call', // Позвонить
                4: 'superbtn-app' // Вызвать врача
            };

            switch (idx) {
                case 0:
                    this.openJivo();
                    break;
                case 1:
                    window.open('https://wa.me/79062631665', '_blank');
                    break;
                case 2:
                    this.openCallme();
                    break;
                case 3:
                    window.open('tel:88126402868', '_blank');
                    break;
                case 4:
                    this.openCallDoctor();
                    break;
            }
            if (typeof ym !== 'undefined') {
                const goal = goalMap[idx] || this.listItems[idx].goal;
                console.log('ym', goal);
                ym(65908693, 'reachGoal', goal);
            }
        },
        setScroll() {
            this.opened = false;
            // this.jivo_api?.close();
            this.currScroll = window.scrollY;
            return this.currScroll;
        },
        openList() {
            if (typeof ym !== 'undefined')
                ym(25121624, 'reachGoal', 'oncallSuperBtn')
            this.opened = true;
            return this.opened;
        },
        closeList() {
            this.opened = false;
            return this.opened;
        },
        toggleList() {
            this.opened = !this.opened;
            return this.opened;
        },
        runJivo() {
            const checkJivoInterval = setInterval(() => {
                if (window?.jivo_api) {
                    clearInterval(checkJivoInterval);
                    if (window?.jivo_api.chatMode() !== "offline") {
                        this.listItems[0].display = true;
                    }
                    this.jivo_api = window?.jivo_api;
                    window.jivo_onClose = async () => {
                        await this.closeJivo()
                    };
                    window.jivo_onMessageReceived = async () => {
                        await this.openJivo()
                    };
                }
            }, 500)
        },
        async openJivo() {
            await this.jivo_api?.open();
            document.body.classList.remove("helper-closed");
        },
        async closeJivo() {
            this.opened = false;
            setTimeout(() => {
                document.body.classList.add("helper-closed");
            }, 100)
        },
        updateIcon() {
            this.changeIcon = !this.changeIcon;

            setTimeout(() => {
                if (this.currIndex < this.listItems.length - 1) {
                    this.currIndex += 1;
                } else {
                    this.currIndex = 0;
                }

                this.currIcon = this.listItems[this.currIndex].iconBig;

                this.changeIcon = !this.changeIcon;
            }, 300);
        },
        startInterval() {
            this.intervalId = setInterval(() => {
                this.updateIcon();
            }, 3000);
        },
        stopInterval() {
            clearInterval(this.intervalId);
        },
        openCallDoctor() {
            window.open('https://oncall.lahtaclinic.ru/app', '_blank');
        },
        closeCallme() {
            this.callmeOpened = false;
        },
        openCallme() {
            // Используем событие для связи с родительским компонентом OnCallPage
            this.$emit('openCallme');
        },
    },
    computed: {
        scrolled() {
            return this.currScroll >= this.hideLimit;
        },
    },
    mounted() {
        this.currIcon = this.listItems[0].iconBig;

        this.startInterval();

        window.addEventListener("scroll", this.setScroll);

        this.runJivo();
        document.body.classList.add("helper-closed");
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.setScroll);
        this.stopInterval();
    },
}

</script>

<style lang="scss">
.oncallsuperbtn-frame {
    .oncallsuperbtn {

        .btn-trigger {
            position: absolute;
            z-index: 100;
        }

        &-wrap {
            position: fixed;
            right: 1.5rem;
            bottom: 2rem;
            z-index: 1000;

            @media (min-width: 640px) {
                & {
                    right: 2rem;
                }
            }
        }

        width: 62px;
        height: 62px;
        overflow: hidden;
        border-radius: 50%;
        background-color: #ffffff;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -2px rgba(0, 0, 0, 0.05);
        z-index: 20;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    @media (max-width: 640px) {
        .oncallsuperbtn {
            width: 62px;
            height: 62px;
        }
    }


    .oncallsuperbtn-item {
        font-size: 16px;
        color: #213043;
        font-family: 'Lato';

        background-color: #ffffff;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        white-space: nowrap;
        margin-bottom: 10px;
        padding: 15px;
        float: right;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 12px 24px 12px 24px;

        &>div>svg {
            margin-left: 15px;
        }
    }

    .fixed {
        position: fixed;
        bottom: 30px;
        right: 30px;
        z-index: 100;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(16px);
        }

        to {
            opacity: 1;
            transform: translate(0px);
        }
    }

    .active {
        opacity: 1;
    }

    .helper-widget {
        opacity: 0;
        transform: translateX(100%);
        transition: opacity 0.4s ease, transform 0.6s ease;
        pointer-events: none;

        &_visible {
            opacity: 1;
            transform: none;
            pointer-events: all;
        }
    }

    .helper-list div {
        animation: fadeIn 0.25s ease-out 1 forwards;
    }

    @for $i from 0 through 4 {
        .helper-list div:nth-child(#{$i}) {
            animation-delay: #{(4 - $i) * 0.1}s;
        }
    }

    .btn-trigger {
        transition: opacity 0.8s ease, transform 0.5s ease;
    }

    .btn-active {
        .btn-trigger {
            pointer-events: none;
            opacity: 0;
            transform: scale(0);
        }

        .cross-icon {
            opacity: 1;
        }
    }

    .helper-list div {
        opacity: 0;
    }

    .cross-icon {
        opacity: 0;
        transition: opacity 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        div {
            background: linear-gradient(315deg, #03ECC9 7.73%, #2E80EA 92.27%);
            width: 24px;
            height: 4px;
            display: block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            transition: transform 0.35s ease;
        }
    }

    .btn-active {
        .cross-icon {
            div {
                &:nth-child(1) {
                    transform: translate(-50%, -50%) rotate(45deg);
                }

                &:nth-child(2) {
                    transform: translate(-50%, -50%) rotate(-45deg);
                }
            }
        }
    }
}

#jvLabelWrap,
.__jivoMobileButton {
    opacity: 0 !important;
    pointer-events: none;
    display: none !important;
}

.helper-closed #jcont {
    opacity: 0 !important;
    pointer-events: none;
    display: none !important;
}

.__jivoMobileButton {
    height: 1px;
    width: 1px;
}
</style>
